module.exports = __webpack_public_path__ + "static/media/check.004db9ba.svg";